import React from 'react';
import { Link } from 'react-router-dom';
import './MobileMenu.css';

export default function MobileMenu({ open, onClose }) {
  if (!open) return null;
  return (
    <div className="mobile-menu-backdrop" onClick={onClose}>
      <nav className="mobile-menu" onClick={e => e.stopPropagation()}>
        <button className="mobile-menu-close" onClick={onClose} aria-label="Close menu">&times;</button>
        <Link to="/" onClick={onClose}>HOME</Link>
        <Link to="/team" onClick={onClose}>OUR TEAM</Link>
        <Link to="/projects" onClick={onClose}>PROJECTS</Link>
        <Link to="/resources" onClick={onClose}>RESOURCES</Link>
        <Link to="/contact" onClick={onClose}>CONTACT</Link>
      </nav>
    </div>
  );
}